import Plyr from "plyr";

// Player
const initPlayers = () => {
  Array.from(document.querySelectorAll(".js-player")).map(
    (p) =>
      new Plyr(p, {
        autoplay: true,
        loop: { active: true },
        muted: true,
      })
  );
};
initPlayers();
